
import { Vue, Component, Prop } from 'vue-property-decorator';

export interface ListType {
  title: string,
  list: { text: string, icon: string }[],
}

@Component
export default class AttentionList extends Vue {
  @Prop({ required: true }) list!: ListType;
}
